module.exports = "//static.hsappstatic.net/LoginUI/static-1.16087/img/onelogin-logo.svg"